import React, { useState } from 'react';
import '../css/slave-portfolio-header-style.css';
import '../css/slave-portfolio-card-style.css';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {useTheme} from "@mui/material/styles";

const SlavePortfolioHeader = (
    {
        data,
        currentOption,
        onChangeOption,
        dataSlave
    }
) => {

    const optionsList = [
        "all",
        "day",
        "week",
        "month",
        "ytd"
    ]

    const currentData = data ? data[currentOption] : null;
    const [showDropdown, setShowDropdown] = useState(false);
    const theme = useTheme();
    const textColor = theme.palette.mode === 'dark' ? 'white' : 'black';

    const toggleDropdown = () => setShowDropdown(!showDropdown);

    const handleOptionClick = (option) => {
        onChangeOption(option);
        setShowDropdown(false);
    };

    return (
        <div className="header">
            <div className='card-column-items alignItemsStart'>
                <Typography style={{fontSize: '25px'}}>{`$${(dataSlave?.totalValue || 0).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).slice(1)}`}
                </Typography>
                <Typography
                    style={{
                        color: currentData.totalProfitLoss < 0 ? 'red' : 'green',
                    }}
                >{`${(currentData?.totalProfitLoss || 0).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })} ${currentData.totalProfitLoss < 0 ? '' : '+'}${(currentData.totalProfitLossPercent * 100).toLocaleString('en-US', {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                })}%`}</Typography>
            </div>

            <div className="dropdown">
                <Box display="flex" alignItems="center" marginBottom={2} onClick={toggleDropdown} sx={{ cursor: 'pointer' }}>
                    <span style={{ fontSize: '17px', color: textColor }}>{currentOption}</span>
                    <ArrowDropDownIcon sx={{
                        transform: showDropdown ? 'rotate(0deg)' : 'rotate(-90deg)',
                        transition: 'transform 0.3s ease',
                    }}/>
                </Box>
                {showDropdown && (
                    <Box  sx={{
                        borderRadius: '8px',
                        position: 'absolute',
                        top: '100%',
                        right: '8%',
                        zIndex: 10,
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'dark' ? '#424242' : 'white',
                        border: (theme) =>
                            `1px solid ${theme.palette.mode === 'dark' ? '#666' : '#ccc'}`,
                        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                        px: '0.5rem',
                    }}>
                        {optionsList.map((option) =>
                            <p onClick={() => handleOptionClick(option)}>{option}</p>
                        )
                        }
                    </Box>

                )}
            </div>
        </div>
    );
};

export default SlavePortfolioHeader;
